import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  headerButton: {
    marginLeft: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
  tabs: {
    marginBottom: theme.spacing(2),
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  tabInfoIcon: {
    display: 'flex',
    alignItems: 'center',
  },
}))

export default useStyles
